<template>
    <add-edit-threat></add-edit-threat>
</template>

<script>
import AddEditThreat from "@/layouts/components/risk-management/threats/addedit-threat.vue";

export default {
 components : {
   AddEditThreat
 },
};
</script>